// frontend/admin-portal/src/services/orderService.js
import api from './axiosConfig';

export const orderService = {
    list: async (params = {}) => {
        const { data } = await api.get('/orders', { params });
        return data.data;
    },
    stats: async () => {
        const { data } = await api.get('/orders/stats');
        return data.data;
    },
    get: async (id) => {
        const { data } = await api.get(`/orders/${id}`);
        return data.data.order;
    },
    create: async (payload) => {
        const { data } = await api.post('/orders', payload);
        return data.data.order;
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/orders/${id}`, payload);
        return data.data.order;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/orders/${id}`);
        return data;
    },
    send: async (id) => {
        const { data } = await api.patch(`/orders/${id}/send`);
        return data.data.order;
    },
    accept: async (id) => {
        const { data } = await api.patch(`/orders/${id}/accept`);
        return data.data.order;
    },
    reject: async (id, reason) => {
        const { data } = await api.patch(`/orders/${id}/reject`, { reason });
        return data.data.order;
    },
    fulfill: async (id) => {
        const { data } = await api.patch(`/orders/${id}/fulfill`);
        return data.data.order;
    },
    cancel: async (id, reason) => {
        const { data } = await api.patch(`/orders/${id}/cancel`, { reason });
        return data.data.order;
    },
    convertToOrder: async (id) => {
        const { data } = await api.patch(`/orders/${id}/convert`);
        return data.data.order;
    },

    downloadPdf: async (id, code) => {
        const res = await api.get(`/orders/${id}/pdf`, { responseType: 'blob' });
        const filename = `${(code || `order-${id}`).replace(/[^a-z0-9-]/gi, '_')}.pdf`;
        const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    },

    downloadExcel: async (id, code) => {
        const res = await api.get(`/orders/${id}/excel`, { responseType: 'blob' });
        const filename = `${(code || `order-${id}`).replace(/[^a-z0-9-]/gi, '_')}.xlsx`;
        const url = URL.createObjectURL(new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }));
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    },

    getDefaults: async () => {
        const { data } = await api.get('/orders/defaults');
        return data.data;
    },
};